module.exports = __webpack_public_path__ + "img/6.4209b175.png";